module.exports = __webpack_public_path__ + "img/trainings.8c4fc26a.svg";